module.exports = __webpack_public_path__ + "img/auth-company.ddcdbe79.png";